export default __webpack_public_path__ + "static/media/icon-big-email-esim-88-px.48bf6f22.svg";